import React, { useState, useEffect } from "react";

const EmployeeForm = ({
  addEmployee,
  updateEmployee,
  selectedEmployee,
  organizations = [],
  roles = [],
  setActiveView,
}) => {
  const [formData, setFormData] = useState({
    organizationId: "",
    firstName: "",
    lastName: "",
    position: "",
    email: "",
    phone: "",
    roleId: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (selectedEmployee) {
      setFormData({
        organizationId: selectedEmployee.organizationId || "",
        firstName: selectedEmployee.firstName || "",
        lastName: selectedEmployee.lastName || "",
        position: selectedEmployee.position || "",
        email: selectedEmployee.email || "",
        phone: selectedEmployee.phone || "",
        roleId: selectedEmployee.roleId ? selectedEmployee.roleId.toString() : "",
        password: "",
        confirmPassword: "",
      });
    } else if (organizations && organizations.length > 0) {
      setFormData((prev) => ({
        ...prev,
        organizationId: organizations[0].id.toString(),
      }));
    }
  }, [selectedEmployee, organizations]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "roleId" && value && roles && Array.isArray(roles)) {
      const selectedRole = roles.find((role) => role.id === parseInt(value, 10));
      if (selectedRole) {
        setFormData((prev) => ({
          ...prev,
          roleId: value,
          position: selectedRole.name,
        }));
        return;
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedEmployee) {
      if (formData.password.length < 8) {
        alert("Password must be at least 8 characters long.");
        return;
      }
      if (formData.password !== formData.confirmPassword) {
        alert("Password and Confirm password do not match.");
        return;
      }
    } else if (formData.password || formData.confirmPassword) {
      if (formData.password !== formData.confirmPassword) {
        alert("New password and Confirm password do not match.");
        return;
      }
      if (formData.password && formData.password.length < 8) {
        alert("Password must be at least 8 characters long.");
        return;
      }
    }

    const employeeData = {
      ...formData,
      organizationId: parseInt(formData.organizationId, 10),
      roleId: formData.roleId ? parseInt(formData.roleId, 10) : null,
    };

    if (selectedEmployee) {
      const payload = {
        ...selectedEmployee,
        ...employeeData,
      };
      if (!payload.password) {
        delete payload.password;
        delete payload.confirmPassword;
      } else {
        delete payload.confirmPassword;
      }
      updateEmployee(payload);
    } else {
      delete employeeData.confirmPassword;
      addEmployee(employeeData);
    }
  };

  return (
    <div className="form-container">
      <h2>
        <span>{selectedEmployee ? "✏️" : "➕"}</span>
        {selectedEmployee ? "Edit Employee" : "Add New Employee"}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName">First Name *</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              className="form-input"
              value={formData.firstName}
              onChange={handleChange}
              required
              placeholder="Enter first name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name *</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              className="form-input"
              value={formData.lastName}
              onChange={handleChange}
              required
              placeholder="Enter last name"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="roleId">Role *</label>
            <select
              id="roleId"
              name="roleId"
              className="form-input"
              value={formData.roleId}
              onChange={handleChange}
              required
            >
              <option value="">Select a role</option>
              {roles &&
                Array.isArray(roles) &&
                roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name} {role.department ? `(${role.department})` : ""}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="organizationId">Organization *</label>
            <select
              id="organizationId"
              name="organizationId"
              className="form-input"
              value={formData.organizationId}
              onChange={handleChange}
              required
            >
              <option value="">Select an organization</option>
              {organizations &&
                Array.isArray(organizations) &&
                organizations.map((org) => (
                  <option key={org.id} value={org.id}>
                    {org.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="email@example.com"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">Phone *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+374XXXXXXXX"
            />
          </div>

          {!selectedEmployee ? (
            <>
              <div className="form-group">
                <label htmlFor="password">Password *</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={8}
                  placeholder="Min 8 chars, upper, lower, number, special"
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm password *</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-input"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  minLength={8}
                  placeholder="Repeat password"
                  autoComplete="new-password"
                />
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label htmlFor="password">New password (leave blank to keep)</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Min 8 chars, upper, lower, number, special"
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm new password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-input"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Repeat if changing password"
                  autoComplete="new-password"
                />
              </div>
            </>
          )}
        </div>

        <div className="form-row">
          {formData.roleId && roles && Array.isArray(roles) && (
            <div className="form-group">
              <label>Selected Role Info</label>
              <div
                className="role-info"
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "0.8rem",
                  borderRadius: "6px",
                  border: "1px solid #e9ecef",
                  fontSize: "0.9rem",
                }}
              >
                {(() => {
                  const selectedRole = roles.find(
                    (r) => r.id === parseInt(formData.roleId),
                  );
                  if (selectedRole) {
                    return (
                      <>
                        <div>
                          <strong>{selectedRole.name}</strong>
                        </div>
                        <div style={{ color: "#7f8c8d", marginTop: "0.3rem" }}>
                          {selectedRole.description && (
                            <div>{selectedRole.description}</div>
                          )}
                          {selectedRole.department && (
                            <div>Department: {selectedRole.department}</div>
                          )}
                          {selectedRole.level && (
                            <div>Level: {selectedRole.level}</div>
                          )}
                        </div>
                      </>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
          )}
        </div>

        <div className="form-buttons">
          <button
            type="button"
            className="cancel-btn"
            onClick={() => setActiveView("employees")}
          >
            Cancel
          </button>
          <button type="submit" className="submit-btn">
            {selectedEmployee ? "Save Changes" : "Add Employee"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeForm;
